<template>
  <div class="card-barcode">
    <BarcodeCanvas
      :value="resolvedSourceValue"
      :format="field.barcode_format"
      :height="24"
    />
  </div>
</template>

<script>
import sourceFieldReferenceField from '@baserow/modules/database/mixins/sourceFieldReferenceField'
import BarcodeCanvas from '@baserow/modules/database/components/field/BarcodeCanvas'

export default {
  name: 'RowCardFieldBarcode',
  components: { BarcodeCanvas },
  mixins: [sourceFieldReferenceField],
  height: 32,
  props: {
    row: { type: Object, required: true },
    field: { type: Object, required: true },
    value: { type: null, default: null },
  },
}
</script>
